import { createDeviceCipher } from "./e2e-crypto";

/**
 * Step 8 end-to-end encryption (Step 8 PRD §6; AUTHORIZATION_SPEC §Step 8).
 *
 * Step 8's list names real people who never agreed to be in an app, so it gets
 * the same treatment as Step 4's inventory: encrypted on this device, with the
 * server holding ciphertext only and no read path.
 *
 * Two differences from Step 4, both deliberate:
 *   - Its own device key, because the two lists have different lifecycles
 *     (Step 4 is usually deleted after Step 5; this one persists into Step 9).
 *   - Rows are updated in place, not written once: willingness moves, rows get
 *     edited, and Step 9 will write outcomes onto them. Each save re-encrypts
 *     the whole row, so a fresh IV is used every time (see e2e-crypto.ts).
 */
const step8Cipher = createDeviceCipher("happy24.step8.key");

/** True if a key already exists on this device (i.e. rows written here). */
export const hasStep8Key = step8Cipher.hasKey;
/** Encrypt a person's row → opaque base64 (iv ‖ ciphertext). */
export const encryptRow = step8Cipher.encryptRow;
/** Decrypt a row, or null when this device doesn't hold the right key. */
export const decryptRow = step8Cipher.decryptRow;
